import { render, staticRenderFns } from "./MobileTopHeader.vue?vue&type=template&id=0a56e7c8&scoped=true&"
import script from "./MobileTopHeader.vue?vue&type=script&lang=js&"
export * from "./MobileTopHeader.vue?vue&type=script&lang=js&"
import style0 from "./MobileTopHeader.vue?vue&type=style&index=0&id=0a56e7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a56e7c8",
  null
  
)

export default component.exports